import request from '@/utils/request'

// 不具合写真 削除
export function defectPhotoDelete(data) {
  return request({
    url: `/api/defectPhoto/delete/${data.reportNo}`,
    method: 'post',
    data,
  })
}
// 不具合報告
export function getDefectReport(data) {
  return request({
    url: `/api/defectReport/foundDefectReport`,
    method: 'post',
    data,
  })
}
// 不具合報告
export function downloadDefectPhoto(data) {
  return request({
    url: `/api/defectPhoto/download`,
    method: 'post',
    data,
    responseType: 'blob',
  })
}

// 不具合ＮＯマスタ
export function getFaultReportSelect(data) {
  return request({
    url: `/api/mprbnop/foundData`,
    method: 'post',
    data,
  })
}

// （共通）作業情報取得
export function getReportInfo(data) {
  return request({
    url: `/api/workingPlanAndResult/queryWorkingPlanAndResultInfo/${data}`,
    method: 'get',
  })
}
// 作業報告書提出>報告書一覧
export function getReportFile(data) {
  return request({
    url: `/api/reportFileRc/foundData`,
    method: 'post',
    data,
  })
}
// workNoを条件として 同じグループの作業を取得する
export function getWorkNoList(data) {
  return request({
    url: `/api/workingPlanAndResult/getSameGroupWorkingPlanAndResult/${data}`,
    method: 'get',
    data,
  })
}
// 報告書 登録と更新
export function handleReportSubmit(data) {
  return request({
    url: `/api/reportBaseRc/submitReportDetailRc`,
    method: 'post',
    data,
  })
}

// 棟リスト検索
export function getmBuildList(data) {
  return request({
    url: `/api/mbuildgp/sections/${data}`,
    method: 'get',
  })
}

// 不具合写真
export function getDefectPhotoList(data) {
  return request({
    url: `/api/defectPhoto/foundSelData`,
    method: 'post',
    data,
  })
}
// 新规查询不具合id
export function getDefectId(data) {
  return request({
    url: `/api/defectReport/submitDefectReport`,
    method: 'post',
    data,
  })
}
// 不具合photo
export function getDefectPhoto(data) {
  return request({
    url: `/api/defectPhoto/foundSelData`,
    method: 'post',
    data,
  })
}

// (DLN 作業未実施住戸登録)報告書基本RC-実施率
export function getCheckRateInfo(data) {
  return request({
    url: `/api/reportBaseRc/checkRateInfo`,
    method: 'post',
    data,
  })
}
// 未実施住戸登録
export function updateWorkUnimplement(data) {
  return request({
    url: `/api/reportBaseRc/workUnimplementUpdate`,
    method: 'post',
    data,
  })
}

// 作業未実施区画情報
export function getWorkUnimplementList(data) {
  return request({
    url: `/api/workUnimplementInfo/foundSelData`,
    method: 'post',
    data,
  })
}

// 棟内区画
export function getBuildingPartition(data) {
  return request({
    url: `/api/mroombp/query`,
    method: 'post',
    data,
  })
}
// 作業実施情報
export function getWorkImplementList(data) {
  return request({
    url: `/api/workImplementInfo/queryList`,
    method: 'post',
    data,
  })
}
// 報告書一覧
export function getReportDetails(data) {
  return request({
    url: `/api/reportDetailRc/foundRelatData`,
    method: 'post',
    data,
  })
}

export function getReportDetail(data) {
  return request({
    url: `/api/work/report/detail`,
    method: 'post',
    data,
  })
}
// 総設分類1
export function getComprehensiveClassification1(data) {
  return request({
    url: `/api/mfacrp1p/many`,
    method: 'post',
    data,
  })
}
// 総設分類2
export function getComprehensiveClassification2(data) {
  return request({
    url: `/api/mfacrp2p/many`,
    method: 'post',
    data,
  })
}

// 総設分類3
export function getComprehensiveClassification3(data) {
  return request({
    url: `/api/mfacrp3p/many`,
    method: 'post',
    data,
  })
}

// 建築設備リスト 条件により検索処理を行う
export function getCreateDate(data) {
  return request({
    url: `/api/equipmentInspection/foundMfacilp`,
    method: 'post',
    data,
  })
}

// 建築設備リスト 条件により検索処理を行う
export function submitEquipmentInspection(data) {
  return request({
    url: `/api/reportBaseRc/submitEquipmentInspection`,
    method: 'post',
    data,
  })
}
// 総合設備点検 検索処理 今回報告書
export function getCurrentReport(data) {
  return request({
    url: `/api/equipmentInspection/foundDataC`,
    method: 'post',
    data,
  })
}
// 総合設備点検
export function getEquipmentInspectionFile1(data) {
  return request({
    url: `/api/equipmentInspection/exportInspection1`,
    method: 'post',
    data,
    responseType: 'blob',
  })
}
// 別紙_点検総括表_2
export function getDefectReportFile(data) {
  return request({
    url: `/api/defectReport/exportInspection2`,
    method: 'post',
    data,
    responseType: 'blob',
  })
}

export function geEquipmentId(data) {
  return request({
    url: `/api/reportDetailRc/submitReportDetailRc`,
    method: 'post',
    data,
  })
}

export function getPreReport(data) {
  return request({
    url: `/api/equipmentInspection/foundDataP`,
    method: 'post',
    data,
  })
}

// 報告書一つ催促
export function reportUrgeOne(data) {
  return request({
    url: `/api/reportBaseRc/urgeAndMailOne/${data.reportId}/${data.urgeType}`,
    method: 'get',
  })
}
// 報告書基本RC
export function getReportRcInfo(reportId) {
  return request({
    url: `/api/reportBaseRc/${reportId}`,
    method: 'get',
  })
}
// 報告書パターンを取得する
export function urgeAndMailOneByParams(itemDetailCd, workSpecCd) {
  return request({
    url: `/api/reportBaseRc/getReportPatternRc/${itemDetailCd}/${workSpecCd}`,
    method: 'get',
  })
}
// 報告書パターンを取得する
export function urgeAndMailOneByParamsOne(itemDetailCd) {
  return request({
    url: `/api/reportBaseRc/getReportPatternRc/${itemDetailCd}`,
    method: 'get',
  })
}

// (（共通）作業情報取得)前回報告書NOを取得し
export function getPreNormalReport(data) {
  return request({
    url: `/api/workingPlanAndResult/getPreviousReportNo`,
    method: 'post',
    data,
  })
}
// (DLN)報告書新規追加また更新
export function insOrUpd(data) {
  return request({
    url: `/api/reportBaseRc/insOrUpd`,
    method: 'post',
    data,
  })
}
// (DLN 作業未実施住戸登録)条件により検索処理を行う
export function getworkImplementInfoList(reportId) {
  return request({
    url: `/api/workImplementInfo/queryList/${reportId}`,
    method: 'get',
  })
}

// （DLN側）総合設備点検不具合NO選択
export function mprbnoFoundData(data) {
  return request({
    url: `/api/mprbnop/foundData`,
    method: 'post',
    data,
  })
}

// 不具合履歴
export function defectReportHistory(data) {
  return request({
    url: `/api/defectReport/history`,
    method: 'post',
    data,
  })
}
